import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import Session from 'common/services/Session'

import { StepTitle } from 'embed/components/Application/StepTitle'
import ThemeConsumer from 'embed/components/ThemeConsumer'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

type Props = LifeInsuranceApplicationProps & { onContinueToFirstApplicationStep: () => void }

export const RestartApplication: React.SFC<Props> = (props) => {
  React.useEffect(() => {
    if (!Session.isReturningLead) {
      props.onContinueToFirstApplicationStep()
    }
  }, [])

  const handleButtonClick = (shouldResetLead: boolean) => () => {
    if (shouldResetLead) {
      Session.resetLeadUuid()
    }
    props.onContinueToFirstApplicationStep()
  }

  const handleKeyDown = (shouldResetLead: boolean) => (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      handleButtonClick(shouldResetLead)()
    }
  }

  return Session.isReturningLead ? (
    <Wrapper backToPreview={true} hideCta={true} {...props}>
      <StepTitle>Welcome back! Do you want to start over and get new quotes?</StepTitle>
      <div className={styles.buttonList}>
        <Button handleClick={handleButtonClick(true)} handleKeyDown={handleKeyDown(true)} tabIndex={0}>
          Yes
        </Button>
        <Button handleClick={handleButtonClick(false)} handleKeyDown={handleKeyDown(false)} tabIndex={1}>
          No
        </Button>
      </div>
    </Wrapper>
  ) : null
}

interface ButtonProps {
  handleClick: () => void
  handleKeyDown: (event: React.KeyboardEvent<HTMLElement>) => void
  tabIndex: number
}

const Button: React.SFC<ButtonProps> = ({ children, handleClick, handleKeyDown, tabIndex }) => (
  <ThemeConsumer>
    {({ borderRadiusSmall, colorBorder }) => (
      <button
        className={classnames(
          styles.button,
          css`
            border-color: ${colorBorder};
            border-radius: ${borderRadiusSmall};
          `,
        )}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={tabIndex}
      >
        {children}
      </button>
    )}
  </ThemeConsumer>
)
